export default class SearchOption {
  constructor() {
    this._id = -1;
    this._name = undefined;
    this._thumbnailSrc = undefined;
    this._originalObject = undefined;
  }

  getId() {
    return this._id;
  }

  setId(id) {
    this._id = id;
    return this;
  }

  getName() {
    return this._name;
  }

  setName(name) {
    this._name = name;
    return this;
  }

  getThumbnailSrc() {
    return this._thumbnailSrc;
  }

  setThumbnailSrc(thumbnailSrc) {
    this._thumbnailSrc = thumbnailSrc;
    return this;
  }

  getOriginalObject() {
    return this._originalObject;
  }

  setOriginalObject(originalObject) {
    this._originalObject = originalObject;
    return this;
  }
}